import React from 'react';
import PropTypes from 'prop-types';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export type ThumbsUpOutlineProps = SVGPropsWithClassName & {
  size: number;
};

export function ThumbsUpOutline({
  className = '',
  size = 16,
  title = 'Thumbs Up',
  fill = colors.boulder,
}: Partial<ThumbsUpOutlineProps>) {
  const height = size * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 200"
      height={height}
      className={className}
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={
          'M158.74,200.1h-56.8a67.79,67.79,0,0,1-20-2.85L44.84,186.46a7.33,7.33,0,0,1-5.28-7V8' +
          '9.85a13.4,13.4,0,0,1,7.4-12C66,66.77,79,49.7,84.47,29.32c.25-1.84.56-4,.85-6.1.4-3.' +
          '09.64-5.09.75-6.72l1-3.45C91.14,5,97.09,1.94,101.35.84c9.78-2.53,19,2.38,23.65,5.55' +
          ',11.46,10.52,16.9,24.22,16,38.41A75.84,75.84,0,0,1,137.84,66h45.53A25.62,25.62,0,0,' +
          '1,204,107.71a25.31,25.31,0,0,1-8.52,35.58,27.24,27.24,0,0,1-.09,11.3,24.33,24.33,0,' +
          '0,1-13.4,17,27,27,0,0,1,0,3.6,5.41,5.41,0,0,1,.11,1.63,23.49,23.49,0,0,1-23.42,23.3' +
          'Zm-56.81-18H158.6a4.73,4.73,0,0,0,4-1.57,5.47,5.47,0,0,0,1.64-3.87l-.09-2.08a25.16,' +
          '25.16,0,0,0-.42-5.34c-1.55-5.1,1.88-11.4,7.84-13.16l1.43-.31a6.24,6.24,0,0,0,4.88-4' +
          '.9,9.41,9.41,0,0,0-.91-6.66L175.18,141l1.72-8.35,7-4.08a7.35,7.35,0,0,0,4.93-3,7.21' +
          ',7.21,0,0,0-1.27-9.62A11.35,11.35,0,0,1,186,100.15l2.54-2.32h0a7.47,7.47,0,0,0,3.21' +
          '-7.26c-.64-3.7-4.33-7.08-8.14-6.52H110l6.67-13.11a59.84,59.84,0,0,0,6.4-26.75,29.45' +
          ',29.45,0,0,0-9.22-23.74c-2.34-1.47-6-2.67-8-2.15a3.46,3.46,0,0,0-2,1.63c-.15,1.45-.' +
          '35,3-.56,4.65-.46,3.38-.78,5.7-1.15,7.94l-.29,1.5A97,97,0,0,1,57.52,92.6v78.75L87,1' +
          '79.91A53.42,53.42,0,0,0,101.87,182ZM181.14,165c.08.44.16.86.23,1.29a6.32,6.32,0,0,0' +
          '-.23-1.3ZM199,102c.12.09.24.2.36.31A1.59,1.59,0,0,0,199,102ZM55.12,93.9,54.9,94A.94' +
          '.94,0,0,0,55.12,93.9Zm2.4-4.13Z'
        }
        fill={fill}
        transform="translate(0.25 -0.14)"
      />
      <path
        d={
          'M5.11,81.16h12a5.65,5.65,0,0,1,5.35,5.93V187.76a5.66,5.66,0,0,1-5.35,5.94h-12a5.67,' +
          '5.67,0,0,1-5.36-5.94V87.09A5.66,5.66,0,0,1,5.11,81.16Z'
        }
        fill={fill}
        transform="translate(0.25 -0.14)"
      />
    </svg>
  );
}

ThumbsUpOutline.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  fill: PropTypes.string,
};

ThumbsUpOutline.defaultProps = {
  className: '',
  size: 16,
  title: 'Thumbs Up',
  fill: colors.boulder,
};
